
export default {
  props: {
    filters: { type: Array, default: null }
  },
}
